import { styled } from '@mui/material';
import { CustomButtomProps } from './types';
import { ButtonStyled, getClassSizes } from 'shared/components/Button/FlexButton/defaultStyles';

export const FlexButtonStyles = styled(ButtonStyled)<CustomButtomProps>(
  ({ theme, fullWidth, $backgroundColor, $outline, size = 'medium',color }) => ({
    width: fullWidth ? '100%' : 'unset',
    padding: '0rem 2rem',
    borderRadius: '4rem',
    border: $outline ? '1px solid white' : 'unset',
    backgroundColor: $backgroundColor || '#0e77da',
    color: $outline ? 'black' : 'white',


    ...getClassSizes[size],

    '&:hover': {
      backgroundColor: $backgroundColor || theme.palette.info.light,
    },
    '&:disabled': {
      opacity: 0.6,
    },
  }),
);
